/**
 * loadTCTemplates — shared T&C template loader with default-terms fallback.
 *
 * PR-26 §1 (302_): PR-23 §6 added a settings-string fallback for QuoteReviewSend.
 * ChangeOrderReviewSend + QuoteBuilderPage's Choose T&C picker both use the raw
 * getTCTemplates() call and inherit the "empty array despite 214 chars of default
 * terms in settings" defect. Sharing here so all three surfaces agree.
 *
 * Chain:
 *   1. settingsAPI.getTCTemplates() → real templates (if authored)
 *   2. If empty, fetch settingsAPI.getSettings() and look for `tcTemplate` string
 *   3. If present, synthesise a single { id: 'default', name: 'Default terms', content }
 *      entry. Local-only sentinel — the id never reaches the wire.
 *   4. If neither, return [].
 */
import { settingsAPI } from '../services/api';

export async function loadTCTemplates() {
  try {
    const list = await settingsAPI.getTCTemplates();
    const items = Array.isArray(list) ? list : (Array.isArray(list?.data) ? list.data : []);
    if (items.length > 0) return items;
  } catch {
    /* fall through */
  }
  // Fallback: singular tcTemplate string from settings.
  try {
    const settings = await settingsAPI.getSettings();
    const defaultTC = settings?.tcTemplate || settings?.tc_template;
    if (defaultTC && typeof defaultTC === 'string' && defaultTC.trim().length > 0) {
      return [{ id: 'default', name: 'Default terms', content: defaultTC }];
    }
  } catch {
    /* fall through to empty */
  }
  return [];
}
